export default function campoExclusivoNumeros(e, data, setData) {
    let direccion;
    const { direcciones } = data;
    direcciones === undefined ? direccion = {} : [direccion] = direcciones;

    if (!/^[0-9]*?[0-9 ,]*$/.test(e.substring(e.length - 1))) e = e.replace(/.$/, "");
    setData({ ...data, direcciones: [{ ...direccion, telefono: e }] });
}